import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ModalItens = ({ open, onClose, solicitacao }) => {
  // Recebe os itens via props da API real
  const itens = solicitacao?.itens || [];
  const isMobile = useMediaQuery('(max-width:600px)');

  const formatarValor = (valor) => {
    if (!valor) return 'R$ 0,00';
    return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const formatarData = (dataString) => {
    if (!dataString) return '---';
    const data = new Date(dataString);
    return data.toLocaleDateString('pt-BR');
  };

  const calcularValorTotal = () => {
    if (!itens || itens.length === 0) return 0;
    return itens.reduce((total, item) => {
      const valor = Number(item.item_compra?.ITC_VALOR_REVISADO || item.item_compra?.ITC_VALOR_ORIGINAL || 0);
      const quantidade = Number(item.IT_QUANTIDADE || 0);
      return total + (valor * quantidade);
    }, 0);
  };

  const valorTotal = calcularValorTotal();
  const prefeituraNome = solicitacao?.cotacao?.solicitacao?.prefeitura?.PRE_NOME || 'Prefeitura não informada';

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: isMobile ? { margin: 0, borderRadius: 0 } : {},
      }}
    >
      <DialogTitle style={isMobile ? { padding: '12px 8px', fontSize: '1.1rem' } : {}}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" style={isMobile ? { fontSize: '1.1rem' } : {}}>
            Itens da Solicitação {solicitacao?.COM_SOL_ID}
          </Typography>
          <Button onClick={onClose} color="inherit" style={isMobile ? { minWidth: 32, padding: 4 } : {}}>
            <CloseIcon fontSize={isMobile ? 'small' : 'medium'} />
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent dividers style={isMobile ? { padding: 8 } : {}}>
        <Box mb={2} style={isMobile ? { fontSize: '0.98rem' } : {}}>
          <Typography variant="subtitle1" gutterBottom style={isMobile ? { fontSize: '1rem', marginBottom: 2 } : {}}>
            <strong>Prefeitura:</strong> {prefeituraNome}
          </Typography>
          <Typography variant="subtitle1" gutterBottom style={isMobile ? { fontSize: '1rem', marginBottom: 2 } : {}}>
            <strong>Data:</strong> {formatarData(solicitacao?.COM_DATA_VINCULACAO)}
          </Typography>
          <Typography variant="subtitle1" gutterBottom style={isMobile ? { fontSize: '1rem', marginBottom: 2 } : {}}>
            <strong>Status:</strong> {solicitacao?.cotacao?.COT_STATUS || '---'}
          </Typography>
        </Box>
        {isMobile ? (
          <div>
            {itens.length > 0 ? itens.map((item, idx) => {
              const valorUnitario = Number(item.item_compra?.ITC_VALOR_REVISADO || item.item_compra?.ITC_VALOR_ORIGINAL || 0);
              const quantidade = Number(item.IT_QUANTIDADE || 0);
              const valorTotalItem = valorUnitario * quantidade;
              
              return (
                <Box key={idx} mb={2} p={2} border={1} borderRadius={2} borderColor="#e0e0e0" boxShadow={1} bgcolor="#fff">
                  <div style={{ fontWeight: 600, color: '#001f4d', marginBottom: 4 }}>{item.IT_NOME}</div>
                  <div><b>Descrição:</b> {item.IT_DESCRICAO || '---'}</div>
                  <div><b>Quantidade:</b> {quantidade}</div>
                  <div><b>Valor Unitário:</b> {formatarValor(valorUnitario)}</div>
                  <div><b>Valor Total:</b> {formatarValor(valorTotalItem)}</div>
                </Box>
              );
            }) : (
              <Typography align="center" color="textSecondary">Nenhum item encontrado.</Typography>
            )}
            <Box mt={2} textAlign="right">
              <strong>Total da Solicitação: {formatarValor(valorTotal)}</strong>
            </Box>
          </div>
        ) : (
          <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Produto</TableCell>
                    <TableCell>Descrição</TableCell>
                    <TableCell align="center">Quantidade</TableCell>
                    <TableCell align="right">Valor Unitário</TableCell>
                    <TableCell align="right">Valor Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {itens.length > 0 ? itens.map((item, idx) => {
                    const valorUnitario = Number(item.item_compra?.ITC_VALOR_REVISADO || item.item_compra?.ITC_VALOR_ORIGINAL || 0);
                    const quantidade = Number(item.IT_QUANTIDADE || 0);
                    const valorTotalItem = valorUnitario * quantidade;
                    
                    return (
                      <TableRow key={idx}>
                        <TableCell>{item.IT_NOME}</TableCell>
                        <TableCell>{item.IT_DESCRICAO || '---'}</TableCell>
                        <TableCell align="center">{quantidade}</TableCell>
                        <TableCell align="right">{formatarValor(valorUnitario)}</TableCell>
                        <TableCell align="right">{formatarValor(valorTotalItem)}</TableCell>
                      </TableRow>
                    );
                  }) : (
                    <TableRow>
                      <TableCell colSpan={5} align="center">Nenhum item encontrado.</TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell colSpan={4} align="right">
                      <strong>Total da Solicitação:</strong>
                    </TableCell>
                    <TableCell align="right">
                      <strong>{formatarValor(valorTotal)}</strong>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </DialogContent>
      <DialogActions style={isMobile ? { padding: 8 } : {}}>
        <Button onClick={onClose} color="primary" style={isMobile ? { width: '100%' } : {}}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalItens; 